import React from 'react';
import { NavLink } from 'react-router-dom';
import Icon from './AppIcon';

const PrimaryNav = () => {
  const navItems = [
    { path: '/', label: 'Calculator', icon: 'Calculator' },
  ];

  return (
    <nav className="sticky top-16 z-40 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container px-4">
        <div className="flex items-center gap-1 overflow-x-auto py-1">
          {navItems?.map((item) => (
            <NavLink
              key={item?.path}
              to={item?.path}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive
                    ? 'bg-primary text-primary-foreground shadow-sm'
                    : 'text-muted-foreground hover:text-foreground hover:bg-muted'
                }`
              }
            >
              <Icon name={item?.icon} size={16} />
              <span>{item?.label}</span>
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default PrimaryNav;